import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any) => state.get('organizationsListPage') || initialState;

const totalsState = createSelector(selectState, (state) => state.get('totals'));

const donationsTotalState = createSelector(totalsState, (state) => state.get('donationsTotal'));
const deedsTotalState = createSelector(totalsState, (state) => state.get('deedsTotal'));
const volunteerHoursTotalState = createSelector(totalsState, (state) =>
  state.get('volunteerHoursTotal')
);

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectFetchParams = createSelector(selectState, (state) => state.get('fetchParams'));

export const selectError = createSelector(selectState, (state) => state.get('error'));

export const selectInitialized = createSelector(selectState, (state) => state.get('initialized'));

export const selectTotalOrganizations = createSelector(selectState, (state) => state.get('total'));

export const selectTotalDonations = createSelector(donationsTotalState, (state) =>
  state.get('total')
);
export const selectTotalVolunteerHours = createSelector(volunteerHoursTotalState, (state) =>
  state.get('total')
);
export const selectTotalDeeds = createSelector(deedsTotalState, (state) => state.get('total'));

export const selectTotalDonationsLoading = createSelector(donationsTotalState, (state) =>
  state.get('loading')
);
export const selectTotalVolunteerHoursLoading = createSelector(volunteerHoursTotalState, (state) =>
  state.get('loading')
);
export const selectTotalDeedsLoading = createSelector(deedsTotalState, (state) =>
  state.get('loading')
);
